import React from 'react';
import LearningMaterialCard from '../../components/learningMaterialCard/LearningMaterialCard';
import SuggestCard from './SuggestCard';

const ReferenceCardDeck = ({ topicId, cards }) => {
    const hasCards = cards.length > 0;

    // Sort the cards by (upVotes - downVotes) in descending order
    const sortedCards = [...cards].sort((a, b) => (b.upVotes - b.downVotes) - (a.upVotes - a.downVotes));

    return (
        <div className={`reference-card-deck ${!hasCards ? 'center-suggest-card' : ''}`}>
            {sortedCards.map((card) => (
                <LearningMaterialCard
                    key={card._id}
/*                    imgSrc={require('../../assets/images/placeholder1.png')}*/
                    title={card.title}
                    timeEstimate={card.timeEstimate}
                    views={card.views}
                    description={card.description}
                    upVotes={card.upVotes}
                    downVotes={card.downVotes}
                    referenceLink={card.referenceLink}
                    referenceId={card._id}
                    userVote={card.userVote}
                    mediaType={card.mediaType}
                />
            ))}
            {/*<SuggestCard topicId={topicId} />*/}
        </div>
    );
};

export default ReferenceCardDeck;